import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { PrintRoutingModule } from "./print-routing.module";
import { PrintMediaBarcodesComponent } from "./print-media-barcodes/print-media-barcodes.component";

import { MediaBarcodeComponent } from "./media-barcode/media-barcode.component";
import { NgxBarcodeModule } from "@greatcloak/ngx-barcode";
import { PrintReaderBarcodesComponent } from "./print-reader-barcodes/print-reader-barcodes.component";
import { ReaderBarcodeComponent } from "./reader-barcode/reader-barcode.component";
import { PrintMediaSignaturesComponent } from "./print-media-signatures/print-media-signatures.component";
import { MediaSignatureComponent } from "./media-signature/media-signature.component";
import { PrintReaderIdComponent } from "./print-reader-id/print-reader-id.component";
import { ReaderIdComponent } from "./reader-id/reader-id.component";
import { MediaService } from "../main/services/media.service";

@NgModule({
  declarations: [
    PrintMediaBarcodesComponent,
    MediaBarcodeComponent,
    PrintReaderBarcodesComponent,
    ReaderBarcodeComponent,
    PrintMediaSignaturesComponent,
    MediaSignatureComponent,
    PrintReaderIdComponent,
    ReaderIdComponent
  ],
  imports: [CommonModule, PrintRoutingModule, NgxBarcodeModule],
  providers: [MediaService]
})
export class PrintModule {}
